import { OCTOBER } from "../content/october";

/**
 * The two Masters whose visit the October programmes mark, side by side
 * with their names. Sits under the page lede on the register and events
 * pages, as the organisers asked, so the visit is the first thing seen.
 */
export function Masters({ className = "" }: { className?: string }) {
  return (
    <ul
      className={`grid grid-cols-2 gap-4 sm:gap-6 ${className}`}
      aria-label="The visiting Masters"
    >
      {OCTOBER.masters.map((m) => (
        <li key={m.name} className="flex flex-col items-center text-center">
          <div className="aspect-[4/5] w-full max-w-56 overflow-hidden rounded-2xl bg-ivory-deep shadow-soft">
            <img
              src={m.src}
              alt={m.alt}
              loading="lazy"
              className="h-full w-full object-cover object-top"
            />
          </div>
          <p className="font-display mt-3 text-base leading-snug text-ink md:text-lg">
            {m.name}
          </p>
          <p className="eyebrow mt-1">{m.title}</p>
        </li>
      ))}
    </ul>
  );
}
